import { isTransformationType } from '../../../types';
import { getTransformationFn } from './mapper';
export const mapTransformations = (transformations) => {
    return Object.keys(transformations)
        .filter(isTransformationType)
        .map((key) => {
        const mappedTransformantionFn = getTransformationFn(key);
        return (mappedTransformantionFn && mappedTransformantionFn(transformations)) ?? null;
    })
        .filter((transformation, index, self) => !!transformation &&
        index === self.findIndex((obj) => JSON.stringify(transformation) === JSON.stringify(obj)))
        .sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
};
//# sourceMappingURL=index.js.map